import { Button, Stack, Typography } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'
import { Fade, TextInputFieldProps } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { TextInputCell } from './Commons'

type PerOrderLimitInputCellProps = {
  setValue: UseFormSetValue<CreateItemProps>
  hasPurchaseLimitPerOrder: boolean
  inputProps: Omit<TextInputFieldProps, 't'>
  defaultNumber?: number
}
export const PerOrderLimitInputCell: Cell<PerOrderLimitInputCellProps> = ({
  hasPurchaseLimitPerOrder,
  setValue,
  inputProps,
  defaultNumber = 1,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const options = [
    { value: true, label: t('limited') },
    { value: false, label: t('noLimit') },
  ]
  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('perOrderLimitNumberLabel')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('perOrderLimitNumberDesc')}
      </Typography>
      <Stack direction="row" spacing={2} sx={{ py: 2 }}>
        {options.map((option, index) => (
          <Button
            key={index}
            variant={
              hasPurchaseLimitPerOrder === option.value
                ? 'contained'
                : 'outlined'
            }
            onClick={() => {
              setValue('hasPurchaseLimitPerOrder', option.value)
              if (!option.value) {
                setValue('purchaseLimitPerOrder', null, {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              } else {
                setValue('purchaseLimitPerOrder', defaultNumber, {
                  shouldValidate: true,
                  shouldDirty: false,
                })
              }
            }}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
      {hasPurchaseLimitPerOrder && (
        <Fade>
          <TextInputCell textFieldProps={{ sx: { mb: 0 } }} {...inputProps} />
        </Fade>
      )}
    </CellFrame>
  )
}
